import { useLayoutEffect, useState } from 'react';

/**
 * Runs `init` (reset or fill a screen's singleton store) when the screen mounts and returns false until it ran,
 * so the screen renders nothing with the previous visit's state. `init` must be stable.
 */
export function useMountInit(init: () => void): boolean {
  const [ready, setReady] = useState(false);
  useLayoutEffect(() => {
    init();
    // The ready gate is the point of this hook: one extra render after the store is initialised.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setReady(true);
  }, [init]);
  return ready;
}
